import Config from '@config';
import type { ApiResponse } from '@utils/axios-client';
import axiosApi, { axiosRequestWithRetry } from '@utils/axios-client';
import { Environment, Network, RecordSource, Store } from 'relay-runtime';

export const USER_TOKEN_KEY = '_tokenkey';
export const USER_CLAIMS_KEY = '_claims';
export const X_ENVD = '_xenvd';

const GRAPHQL_URL = `${Config.BASE_GRAPHQL_SERVER_URL}/graphql`;

/**
 * Relay `FetchFunction` receives `(request, variables, cacheConfig, ...)`.
 * When Relay provides `cacheConfig.abortSignal` (newer runtimes), forward it to axios so in-flight GraphQL requests can be cancelled on unmount.
 * relay-runtime 10.x does not populate `abortSignal` today; this wiring is forward-compatible.
 */
function getAbortSignalFromCacheConfig(cacheConfig: unknown): AbortSignal | undefined {
    if (cacheConfig == null || typeof cacheConfig !== 'object') {
        return undefined;
    }
    const c = cacheConfig as { abortSignal?: AbortSignal; signal?: AbortSignal };
    return c.abortSignal ?? c.signal;
}

const fetchQuery = async (operation: { text: any }, variables: any, cacheConfig?: unknown) => {
    const signal = getAbortSignalFromCacheConfig(cacheConfig);
    const res: ApiResponse = await axiosRequestWithRetry(
        (config) => axiosApi.post(GRAPHQL_URL, { query: operation.text, variables }, config),
        { signal }
    );
    return res.data;
};

const environment = new Environment({
    network: Network.create(fetchQuery),
    store: new Store(new RecordSource()),
});

/**
 * @param retryNumber — Additional retries after the first attempt (total = `retryNumber + 1`). Default `0`.
 * @param timeout — Per-attempt axios timeout in ms. `0` disables. Default `0`.
 */
export const createEnvironment = (retryNumber: number = 0, timeout: number = 0) => {
    const fetch = async (operation: { text: any }, variables: any, cacheConfig?: unknown) => {
        const signal = getAbortSignalFromCacheConfig(cacheConfig);
        const res: ApiResponse = await axiosRequestWithRetry(
            (config) => axiosApi.post(GRAPHQL_URL, { query: operation.text, variables }, config),
            { retryNumber, timeout, signal }
        );
        return res.data;
    };
    return new Environment({
        network: Network.create(fetch),
        store: new Store(new RecordSource()),
    });
};

export default environment;
